namespace appn.views.taskRecurring.index {

    class InitArgs {
        systemStatuses: Array<SelectListItem> = [];
        allUsersParsed: Array<AppnSelectListItem> = [];
        modelHasTemplates: boolean = false;
        dateFilter: string = emptyString;
        tasksCreate: string = emptyString;
    }

    let _initArgs: InitArgs;

    let _selectedItems;
    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;
        appn.dateFilter.init(_initArgs.dateFilter);
        addEvents();

        appn.taskTemplateFilter.init();
        createDataTable();
    }

    function addEvents() {
        $('#manageBtn').on('click', function(e) {
            appn.dialog.showLoading();
        });

        $('#importBtn').on('click', function(e) {
            appn.dialog.showLoading();
        });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sDom: appn.dataTable.genSDom(1, 0, 4),
            sAjaxSource: 'TaskRecurring/DataTable',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').val()),
                    { name: 'sCustom_1', value: appn.taskTemplateFilter.getStateOrDefault().value },
                    appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()),
                    { name: 'sCustom_3', value: appn.dateFilter.getStateOrDefaultAsString() });
            },
            aaSorting: [[5, 'desc']],
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '25%' },
                { bSortable: false, sWidth: '25%' },
                { bSortable: false, sWidth: '15%' },
                { bSortable: false, sWidth: '15%' },
                { bSortable: true, sWidth: '15%' }
            ],
            fnInitComplete: function() {
                $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.systemStatuses, 'sCustom_0', 'saveMeState', T('ALL STATUSES')));

                $('.dataTables_filter').prepend(appn.elementBuilder.buildAppnSelect(_initArgs.allUsersParsed, 'sCustom_2', 'saveMeState select2-noinit', T('ALL USERS')));

                // Inject Screen Action buttons
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                ], appn.requestUser.isUserOrHigher, true);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'importBtn', buttonType: 'Import' },
                    { buttonId: 'addnew', buttonType: 'AddNew' }
                ], appn.requestUser.isUserOrHigher);

                // Prepend the show button
                (appn as any).sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                if (_initArgs.modelHasTemplates)
                    $('#addnew').on('click', function(e) {
                        e.preventDefault();
                        appn.tasks.showAddNewDialog(true, false, appn.emptyString, appn.emptyString, false);
                    });
                else
                    $('#addnew').on('click', function(e) {
                        e.preventDefault();
                        appn.location.navTo(_initArgs.tasksCreate, [
                            {
                                name: 'isTaskRecurringContext',
                                value: 'true'
                            }
                        ]);
                    });

                $('#importBtn').on('click', function(e) {
                    e.preventDefault();
                    $('#importDialog').modal('show');
                    return false;
                });

                // Bind manage tasks button
                $('#manageBtn').on('click', function(e) {
                    e.preventDefault();
                    if ($(this).css('opacity') === '1') {
                        _selectedItems = $('.selectRow:checked');

                        let userIds = appn.emptyString;
                        $(_selectedItems).map(function() {
                            const id = $(this).attr('id');
                            userIds += `${id},`;
                        });

                        $('#taskRecurringsToManage').val(userIds);
                        $('#manageTasksDialog').modal('show');

                        const submitButton = $('#manageTasksDialog .card-header button[value="Manage_Delete"].btn-danger');
                        submitButton.attr('data-deletedetail', createTrashMessageFromTable(submitButton, _selectedItems));
                    }
                });

                appn.dataTable.addSearchPlaceholder(T(`Filter results where the Recurring Task's <b>Name, User First Name or Last Name</b> contains a keyword typed in here.`));

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                    function() {
                        _dataTable.fnDraw(false);
                    },
                    '.dataTables_filter');

                appn.dialog.showBillUpgradeOnClick();

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                    function() {
                        _dataTable.fnDraw(false);
                    },
                    '.dataTables_filter');

                appn.dialog.showBillUpgradeOnClick();
                select.init({ selector: '#sCustom_2', minimumResultsForSearch: '25' }) // Start displaying 'search' at 25 items
            }
        });
    }

    function createTrashMessageFromTable(button: JQuery<HTMLElement>, selectedRows: any): string {
        let msg: string;
        button.attr('data-deletedetail', emptyString);
        button.attr('data-deletemessage', emptyString);

        if (selectedRows.length > 1) { // If we have multiple items
            const ul = elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
            selectedRows.each(function(index: number, selected: JQuery<HTMLElement>) {
                const name = $($(selected).closest('tr').find('td')[6]).text();
                const desc = $($(selected).closest('tr').find('td')[2]).clone()
                    .children()
                    .remove()
                    .end()
                    .text()
                    .trim();

                const item = T('<b>{0}</b> assigned to <b>{1}</b>', desc, name);
                const li = elementBuilder.createElement('li', undefined, undefined, undefined, item);

                ul.appendChild(li);
            });

            msg = T('These Recurring Task Schedules will be will be permanently deleted.') + `<br>${ul.outerHTML}`;
        } else { // if we have a single item
            const name = $($(selectedRows[0]).closest('tr').find('td')[6]).text();
            const desc = $($(selectedRows[0]).closest('tr').find('td')[2]).clone()
                .children()
                .remove()
                .end()
                .text()
                .trim();

            msg = T('The Recurring Task Schedule <b>{0}</b> assigned to <b>{1}</b> will be will be permanently deleted.', desc, name);
        }

        const p = elementBuilder.createElement('p', undefined, undefined, undefined, msg);

        const p2 = elementBuilder.createElement('p', undefined, undefined, undefined, T('<p><b>Note:</b> Existing instances of the Recurring Task(s), if NOT already in-progress or completed, will be moved to Trash. You will have 30 days to restore from the Trash area before the data is permanently deleted from the system.</p>'));
        button.attr('data-deletemessage', p2.outerHTML);

        return JSON.stringify(p.outerHTML);
    }
}
